"use strict";
/**
 * Re-authentication Modal Handler
 *
 * Shown when the session token has expired or is invalid mid-use
 * (events-handler, order-placement, market-selection-service call
 * showReAuthModal). Runs the SAME phone→code flow as the login page via
 * the shared otp-login controller, so the user re-auths in place without
 * losing their market view.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupReAuthModal = setupReAuthModal;
const ui_1 = require("../../ui");
const otp_login_1 = require("../otp-login");
const events_handler_1 = require("../events-handler");
/**
 * Wire up all event listeners for the re-auth modal.
 * Called once from `initApp`.
 */
function setupReAuthModal() {
    const closeBtn = document.getElementById("close-reauth-modal");
    const overlay = document.querySelector(".reauth-modal-overlay");
    // --- Close / overlay dismiss ---
    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            (0, ui_1.hideReAuthModal)();
            (0, ui_1.hideError)("reauth-error");
        });
    }
    if (overlay) {
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay) {
                (0, ui_1.hideReAuthModal)();
                (0, ui_1.hideError)("reauth-error");
            }
        });
    }
    // --- Two-step OTP flow (shared controller) ---
    (0, otp_login_1.setupOtpLoginFlow)({
        form: "reauth-form",
        phoneStep: "reauth-step-phone",
        phoneInput: "reauth-phone-number",
        codeStep: "reauth-step-code",
        codeInput: "reauth-otp-code",
        submitButton: "reauth-submit",
        resendButton: "reauth-otp-resend",
        changeNumberButton: "reauth-otp-change-number",
        status: "reauth-otp-status",
        error: "reauth-error",
    }, () => {
        (0, ui_1.hideReAuthModal)();
        // Reload markets with the fresh session (parity with the old
        // secret-key modal behavior)
        setTimeout(() => (0, events_handler_1.loadEvents)(), 500);
    });
}
